import React, { LabelHTMLAttributes, memo, useRef } from 'react';
import { ControlLabelPosition } from '../../libraries/ControlLabelPosition';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './ControlLabel.scss';
const rootClassName = 'component-control-label';
export interface ControlLabelProps
  extends LabelHTMLAttributes<HTMLLabelElement> {
  control: JSX.Element;
  labelPosition?: ControlLabelPosition;
  labelGap?: number;
  label: string | number;
}

function ControlLabel({
  control,
  labelPosition,
  labelGap,
  label,
  className,
  ...props
}: ControlLabelProps) {
  const ref = useRef<any>();

  return (
    <label
      {...props}
      className={getMergedClassNames([
        className,
        rootClassName,
        labelPosition ? labelPosition : '',
        control.props?.disabled ? 'disabled' : '',
      ])}
      ref={ref}
      style={labelGap ? { gap: `${labelGap}px` } : {}}
    >
      {control}
      <span className={'nunito'}>{label}</span>
    </label>
  );
}

export default memo(ControlLabel);
